import type { ReactNode } from 'react';

interface Props {
  title: string;
  /** Optional leading control (e.g. a back arrow); the design's list screen has none. */
  leading?: ReactNode;
  trailing?: ReactNode;
}

export function ScreenHeader({ title, leading, trailing }: Props) {
  return (
    <header className="screen-header">
      {leading}
      <span style={{ flex: 1 }}>{title}</span>
      {trailing}
    </header>
  );
}
